<template>
  <div
    v-if="visible"
    class="top-bar"
  >
    <transition
      name="fade-spoiler"
      mode="out-in"
    >
      <div
        key="spoiler"
        @click="onClick"
        v-if="isHidden"
        class="top-bar__spoiler"
        :style="spoilerForeground"
      />
      <a
        key="content"
        v-else
        :target="banner.target"
        :href="banner.url"
        :style="contentForeground"
        class="top-bar__content"
      >
        <button
          type="button"
          class="top-bar__close"
          @click.prevent="close"
        >
          <f-sprite-icon :icon-link="$options.icons.IconClose.id" />
        </button>
      </a>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import IconClose from '@icons/close.svg';

export default {
  name: 'top-bar',

  icons:{
    IconClose,
  },

  inject: ['adaptive'],

  data() {
    return {
      isHidden: true,
    };
  },

  computed: {
    bannerData() {
      return this.$store.state.banners['header_spoiler']?.[0] || {};
    },
    banner() {
      const layout = this.adaptive.isMobile ? 'mobile' : 'desktop';
      return this.bannerData.content?.[layout]?.body || {};
    },
    spoilerForeground() {
      const img = this.banner.svg;
      return img ? `background-image: url(${img})` : '';
    },
    contentForeground() {
      const img = this.banner.hoverSvg;
      return img ? `background-image: url(${img})` : '';
    },
    visible() {
      return !!Object.keys(this.banner).length;
    }
  },

  methods: {
    ...mapActions({
      GET_BANNERS: 'banners/getBanners',
    }),
    onClick() {
      this.isHidden = false;
    },
    close() {
      this.isHidden = true;
    },
  },

  serverPrefetch() {
    return this.GET_BANNERS({ slots: ['header_spoiler'], withCategory: false} );
  },
}
</script>

<style lang="scss">

.top-bar {
  &__spoiler,
  &__content {
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  &__spoiler {
    height: 32px;
    min-height: 32px;
    background-color: $blue;
    background-size: auto 32px;

    @include breakpoint("tablet") {
      height: 40px;
      background-size: auto 40px;
    }
  }

  &__content {
    background-color: $white;
    height: 120px;
    display: block;
    background-size: auto 120px;

    @include breakpoint("tablet") {
      height: 240px;
      background-size: auto 240px;
    }
  }

  &__close {
    cursor: pointer;
    color: $black;
    opacity: .4;
    background: none;
    padding: 0;
    position: absolute;
    right: 14px;
    top: 14px;
    width: 16px;
    height: 16px;

    @include breakpoint("tablet") {
      right: 26px;
      top: 26px;
      width: 20px;
      height: 20px;
    }

    &::after {
      content: "";
      position: absolute;
      left: -8px;
      right: -8px;
      top: -8px;
      bottom: -8px;
    }
  }
}

.top-bar__spoiler.fade-spoiler {
  &-leave-active {
    transition: opacity .4s ease, height .4s ease;
    height: 32px;

    @include breakpoint("tablet") {
      height: 40px;
    }
  }

  &-leave-to {
    height: 120px;

    @include breakpoint("tablet") {
      height: 240px;
    }
  }

  &-enter-active {
    transition: opacity .2s ease, height .2s ease;
    height: 120px;

    @include breakpoint("tablet") {
      height: 240px;
    }
  }

  &-enter-to {
    height: 32px;

    @include breakpoint("tablet") {
      height: 40px;
    }
  }

  &-enter,
  &-leave-active {
    opacity: 0;
  }
}

.top-bar__content.fade-spoiler {
  &-leave-active {
    transition: opacity .2s ease;
  }

  &-enter-active {
    transition: opacity .4s ease;
  }

  &-enter,
  &-leave-active {
    opacity: 0;
  }
}
</style>
